import { CamposGenericos } from "./camposGenericos";

export class ItemParametro extends CamposGenericos {
  defecto: boolean
  descripcion: string
  descripcionParametro: string
  idItem: string
  idParametro: number
  observaciones: string
}
